import { Fragment } from "react";

import { Col } from "reactstrap";
import { H6, UL } from "../../../AbstractElements";
import Searchbar from "./Searchbar";
import UserHeader from "./UserHeader";

const RightHeader = () => {
  return (
    <Fragment>
      <Col
        xxl="7"
        xl="6"
        md="7"
        className="nav-right pull-right right-header col-8 p-0 ms-auto"
      >
        {/* <Col md="8"> */}

        <UL attrUL={{ className: "simple-list nav-menus flex-row" }}>
          <H6 className="mt-2">PHẦN MỀM CƠ SỞ DỮ LIỆU QUẢN LÝ XỬ PHẠT HÀNH CHÍNH</H6>
          <Searchbar />
          <UserHeader />
        </UL>
        {/* </Col> */}
      </Col>
    </Fragment>
  );
};

export default RightHeader;
